// Publish an element's height as a CSS custom property on <html>.
//
// On phones the topbar and the calendar's tool row are both `position: sticky`,
// and the month titles have to stick *below* them — otherwise a month heading
// slides under the topbar and the two overlap. Their heights depend on the
// font, the safe-area inset and how the brand name wraps, so they cannot be
// hard-coded; this measures them and hands the number to CSS.

export function publishHeight(node: HTMLElement, name: string) {
  let prop = name;

  const set = () => {
    const h = Math.round(node.getBoundingClientRect().height);
    document.documentElement.style.setProperty(prop, `${h}px`);
  };

  set();

  let ro: ResizeObserver | undefined;
  try {
    ro = new ResizeObserver(set);
    ro.observe(node);
  } catch {
    /* no ResizeObserver — the one-off measurement above still applies */
  }
  window.addEventListener("resize", set, { passive: true });

  return {
    update(next: string) {
      if (next === prop) return;
      document.documentElement.style.removeProperty(prop);
      prop = next;
      set();
    },
    destroy() {
      ro?.disconnect();
      window.removeEventListener("resize", set);
      document.documentElement.style.removeProperty(prop);
    },
  };
}
